import {
  CLEAR_SHEDULE,
  CLEAR_SHEDULE_FLAGS,
  CREATE_SHEDULE_INIT,
  CREATE_SHEDULE_SUCCESS,
  DELETE_SHEDULE_INIT,
  DELETE_SHEDULE_SUCCESS,
  UPDATE_SHEDULE_INIT,
  UPDATE_SHEDULE_SUCCESS,
  ERROR_SHEDULE,
  LIST_SHEDULE_INIT,
  LIST_SHEDULE_SUCCESS
} from 'src/redux/actionTypes';

export const listSheduleInit = (data: any) => ({
  type: LIST_SHEDULE_INIT,
  payload: data
});

export const listSheduleSuccess = (data: any) => ({
  type: LIST_SHEDULE_SUCCESS,
  payload: data
});

export const createSheduleInit = (data: any) => ({
  type: CREATE_SHEDULE_INIT,
  payload: data
});

export const createSheduleSuccess = (data: any) => ({
  type: CREATE_SHEDULE_SUCCESS,
  payload: data
});

export const updateSheduleInit = (data: any) => ({
  type: UPDATE_SHEDULE_INIT,
  payload: data
});

export const updateSheduleSuccess = (data: any) => ({
  type: UPDATE_SHEDULE_SUCCESS,
  payload: data
});

export const deleteSheduleInit = (data: any) => ({
  type: DELETE_SHEDULE_INIT,
  payload: data
});

export const deleteSheduleSuccess = (data: any) => ({
  type: DELETE_SHEDULE_SUCCESS,
  payload: data
});

export const errorShedule = (data: any) => ({
  type: ERROR_SHEDULE,
  payload: data
});

export const clearShedule = () => ({
  type: CLEAR_SHEDULE
});

export const clearSheduleFlags = () => ({
  type: CLEAR_SHEDULE_FLAGS
});
